<template>
  <div v-if="components.length === 0" class="not-exist" :class="{ 'in-pc': isInPc }">
    <div v-if="isInPc">
      <img src="@/assets/images/qs_pc.png" alt="">
      <p>电脑端未配置内容，请用手机打开</p>
    </div>
    <div v-else>
      <img src="@/assets/images/qs_gzh.png" alt="">
      <p>手机端未配置内容，请用电脑打开</p>
    </div>
  </div>
  <div v-else id="container" class="page" :class="{ pc: isInPc }" :style="pageStyle">
    <Loader
      v-for="cmp in components"
      :key="cmp.domId"
      :vueName="cmp.type"
      :component="cmp"
      preview />
    <Loader
      v-for="cmp in suspComps"
      :key="cmp.domId"
      :vueName="cmp.type"
      :component="cmp"
      preview />
    <div
      v-for="cmp in floorNavComps"
      :key="cmp.domId"
      class="floor-nav-item">
      <Loader
        :vueName="cmp.type"
        :component="cmp"
        preview />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils/util'
import { openInstall } from '@/utils/openIntall'
import { mobilecheck, isWeixin } from '@/utils/ua'
import { setWxShareInfo } from '@/utils/wx'
import { completeUrl } from '@/plugin/image-compress'
import Loader from '@/components/asyncComponent'
import { receiveBenefits } from '@/api/user.js'
export default {
  name: 'Main',
  components: {
    Loader
  },
  data () {
    return {
      preview: true,
      isWeixin: isWeixin(),
      loadingInstance: null
    }
  },
  computed: {
    ...mapState('config', ['env']),
    ...mapState('editor', ['pageSet', 'components', 'head', 'suspComps', 'floorNavComps']),
    ...mapState('user', ['userInfo']),
    ...mapState('pay', ['payLoading']),
    keywords () {
      if (this.head && this.head.tdk) {
        return this.head.tdk + ',免费模板'
      }
      return '易企秀-免费H5页面制作工具-微信H5页面,微信朋友圈会议邀请函,电子贺卡,动态音乐相册,电子微杂志,节日贺卡等,易企秀提供海量H5微场景模板,轻松制作一键生成H5页面,为您助力移动自营销,酷炫展示H5企业自营销页面-易企秀官网'
    },
    description () {
      if (this.head && this.head.keyword) {
        return this.head.keyword + '-易企秀，人人会用的创意设计平台'
      }
      return ''
    },
    pageStyle () {
      return utils.styleArrayToStyle(this.pageSet.moduleContent.style)
    },
    isInPc () {
      return !mobilecheck()
    }
  },
  head: {
    title () {
      return {
        inner: this.head.name
      }
    },
    meta () {
      return [
        { name: 'description', content: this.description },
        { name: 'keywords', content: this.keywords }
      ]
    }
  },

  watch: {
    payLoading (val) {
      !this.loadingInstance &&
        (this.loadingInstance = this.$loading('疯狂加载中，模板即将打开...'))
      if (val) {
        this.loadingInstance.show()
      } else {
        this.loadingInstance.close()
      }
    }
  },
  methods: {
    checkLogin () {
      if (!this.userInfo || !this.userInfo.id) {
        this.layout.eqxLayoutShowAuth({ type: 'login' })
        return true
      }
      return false
    }
  },
  created () {
    this.$bus.$on('member', (value) => {
      if (this.checkLogin()) return
      const searchObj = { ...value || {} }
      let searchStr = ''
      for (let attr in searchObj) {
        searchStr += `&${attr}=${searchObj[attr]}`
      }
      searchStr = searchStr && searchStr.slice(1)
      this.dialog.openPay({
        url: `${this.env.host.client}/mall-pay/member?${searchStr}`,
        backgroundTapClose: false
      }).then(res => {
        switch (res.msgType) {
          // 购买成功
          case 'success':
            this.$message({
              type: 'success',
              message: '恭喜您成功购买会员！',
              duration: 2000,
              onClose: () => {
                window.location.reload()
              }
            })
            break
          case 'close':
            break
        }
      })
    })
    this.$bus.$on('receiveBenefits', ({ activityId, cb }) => {
      if (!this.userInfo || !this.userInfo.id) {
        this.layout.eqxLayoutShowAuth({ type: 'login' }).catch((e) => {
          cb && cb()
        })
        return
      }
      receiveBenefits(activityId).then(() => {
        cb && cb()
      }).catch(() => {
        cb && cb()
      })
    })
    this.$bus.$on('login', (value) => {
      this.layout.eqxLayoutShowAuth({ type: 'login' })
    })
    if (this.isWeixin) {
      setWxShareInfo({
        title: this.head.title,
        desc: '制作炫酷电子邀请函、海报视频、投票问卷，就用易企秀',
        link: window.location.href,
        imgUrl: this.head.cover ? completeUrl(this.head.cover) : 'https://asset.eqh5.com/group2/M00/7F/9B/yq0KXlZNGfWAbZo_AAAdI0Feqt0138.png'
      })
    }
    if (topicParams.fn === 'openInstall' && window.location.href.indexOf('feedback') === -1) {
      window.location.href = window.location.href + '&feedback=' + utils.getCookie('feedback')
    }
  },
  mounted () {
    // tracker 埋点
    try {
      window.scene = this.head || {}
    } catch (e) {}
    // WAP端当url中有openInstall标识时尝试唤起APP
    try {
      if (mobilecheck() && topicParams.fn === 'openInstall') {
        openInstall({ force: true })
      }
    } catch (e) {
    }
  }
}
</script>

<style lang="scss" scoped>
.not-exist {
  background-color: #F5F8FF;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  text-align: center;
  &.in-pc {
    padding: 140px 0 80px;
    min-height: calc(100vh - 463px);
  }
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  img {
    width: 220px;
  }
  p {
    margin-top: 16px;
  }
}
#container {
  &.pc {
    padding-top: 60px;
    min-width: 1200px;
  }
}

.page {
  padding-bottom: 1px;
}

.floor-nav-item {
  width: 70px;
  position: fixed;
  top: 50%;
  left: 0;
  z-index: 100;
  transform: translate(0,-50%);
}
</style>

<style lang="scss">
#app .eqx-footer-inner {
  border-top: 0;
}
</style>
